export default {
  getId: state => state.id,
  getIsApproved: state => state.currentStatus === 'approved',
  getStep: state => step => state[step],
  getAllSteps: state => {
    return {
      intro: state.intro,
      questions: state.questions,
      vehicleInfo: state.vehicleInfo,
      companyInformation: state.companyInformation,
    };
  },
  getActiveStep: (state, getters) => {
    const steps = Object.entries(getters.getAllSteps)
      .map(([key, { isCompleted }]) => {
        return { key, isCompleted };
      })
      .filter(({ isCompleted }) => !isCompleted);

    return steps.length > 0 ? steps[0].key : null;
  },
  getSteps: (state, getters) => {
    return Object.entries(getters.getAllSteps).map(([key, value]) => {
      return {
        title: value.step.toLocaleUpperCase(),
        name: key,
        isActive: key === getters.getActiveStep,
        isCompleted: value.isCompleted,
      };
    });
  },
  getAllStepsCompleted: (state, getters) => {
    return (
      getters.getIsApproved ||
      getters.getSteps.filter(({ isCompleted }) => !isCompleted).length === 0
    );
  },
};
